export type GbuDescription = {
  assessment: string;
  dangerous_answer: string;
  possible_remedy: string;
};

const tryParseJsonObject = (value: unknown): any | null => {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return null;

  try {
    return JSON.parse(trimmed);
  } catch {
    return null;
  }
};

const coerceGbuDescriptionFromObject = (value: unknown): GbuDescription | null => {
  if (!value) return null;
  if (typeof value !== "object" || Array.isArray(value)) return null;
  const obj: any = value;

  const assessment = obj.assessment ?? obj.measurement_definition_assessment;
  const dangerous_answer = obj.dangerous_answer ?? obj.measurement_definition_dangerous_answer;
  const possible_remedy = obj.possible_remedy ?? obj.measurement_definition_possible_remedy;

  const hasAny =
    assessment !== undefined || dangerous_answer !== undefined || possible_remedy !== undefined;
  if (!hasAny) return null;

  return {
    assessment: typeof assessment === "string" ? assessment : String(assessment ?? ""),
    dangerous_answer:
      typeof dangerous_answer === "string"
        ? dangerous_answer
        : String(dangerous_answer ?? ""),
    possible_remedy:
      typeof possible_remedy === "string" ? possible_remedy : String(possible_remedy ?? ""),
  };
};

export const parseGbuDescription = (value: unknown): GbuDescription | null => {
  if (!value) return null;
  if (typeof value === "string") {
    const parsed = tryParseJsonObject(value);
    return coerceGbuDescriptionFromObject(parsed);
  }
  return coerceGbuDescriptionFromObject(value);
};
